function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.classList.add('iframe-wrapper');
  wrapper.appendChild(el);
}


document.addEventListener('DOMContentLoaded', () => {
  const $iframe = document.querySelector('.map iframe');
  if (typeof($iframe) != 'undefined' && $iframe != null) {
    wrap($iframe, document.createElement('div'));
  }

  /*
  const $iframe1 = document.querySelector('.modal-card-body iframe');
  if (typeof($iframe1) != 'undefined' && $iframe1 != null) {
    wrap($iframe1, document.createElement('div'));
  }
  */
  const $iframes = document.querySelectorAll('.modal-card-body iframe');
  var $iframes_array = [...$iframes]; // converts NodeList to Array
  $iframes_array.forEach(iframe => {
    if (typeof(iframe) != 'undefined' && iframe != null) {
      wrap(iframe, document.createElement('div'));
    }
  });

});

